import React from 'react';
import { useAuth } from '../AuthContext';
import skierAvatar from '../assets/skier.png';
import snowboarderAvatar from '../assets/snowboarder.png';

const ProfileHeader = () => {
  const { userData } = useAuth();
  const defaultAvatar =
    userData?.sport?.toLowerCase() === 'snowboard' ? snowboarderAvatar : skierAvatar;

  return (
    <div className="flex items-center space-x-4 p-4 border-b">
      <img
        src={userData?.photoURL || defaultAvatar}
        alt="Profile"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = defaultAvatar;
        }}
        className="w-16 h-16 rounded-full object-cover border"
      />
      <div>
        <h2 className="text-lg font-semibold">{userData?.name || 'User'}</h2>
        <p className="text-sm text-gray-600">
          {userData?.country || 'Unknown'} • {userData?.role || 'student'}
        </p>
        {(userData?.orgName || userData?.orgId) && (
          <p className="text-sm text-gray-500">
            {userData?.orgName || userData?.orgId}
            {userData?.orgRole ? ` • ${userData.orgRole}` : ''}
          </p>
        )}
      </div>
    </div>
  );
};

export default ProfileHeader;
